import localDB from "./localDB";

let GLOBAL = require('./globals');

const NotificationsData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/notifications/shopping-list`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    }
};

export default NotificationsData;


// WEBPACK FOOTER //
// ./src/data/NotificationsData.js